export default {
      id: "user-usage",
      viewBox: "-42 0 512 512.001",
      url: "/assets/svg/" + "sprite.svg#user-usage",
      toString: function () {
        return this.url;
      }
    }